<template>
  <div id="login">
    <WaveBg />
    <LoginForm />
  </div>
</template>

<script>
import WaveBg from '@/components/common/WaveBackground.vue';
import LoginForm from '@/components/public/LoginForm.vue';

export default {
  components: {
    WaveBg,
    LoginForm,
  },
};
</script>

<style scoped>
#login {
  /** Center the login form  */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  padding: 4em 0;
}
</style>
